export function getAcao({ qtd_inicial, qtd_ajustada }) {
  if (Number(qtd_inicial || 0) === 0 && Number(qtd_ajustada || 0) > 0) return 'ADICIONADO';

  if (Number(qtd_ajustada || 0) === 0) return 'EXCLUIDO';

  if (Number(qtd_inicial || 0) > Number(qtd_ajustada || 0)) return 'REDUZIU';

  if (Number(qtd_inicial || 0) > 0 && Number(qtd_inicial || 0) < Number(qtd_ajustada || 0)) return 'AUMENTOU';

  return null;
}

export function coberturaFuturaEmDias ({
  consumo_medio_mensal,
  sugestao,
  estoque_futuro_tempo_ressuprimento,
}) {
  if (!Number(consumo_medio_mensal)) {
    return 0
  }

  const estoque_futuro_tempo_ressuprimento_mais_pedido = Number(estoque_futuro_tempo_ressuprimento || 0) + Number(sugestao || 0);

  if (estoque_futuro_tempo_ressuprimento_mais_pedido === 0) {
    return 0;
  }

  return estoque_futuro_tempo_ressuprimento_mais_pedido / (Number(consumo_medio_mensal) / 30.0);
}
